import { useCallback, useMemo } from "react";
import { useLivePreview } from "@payloadcms/live-preview-react";
import { getPayloadCmsUrl } from "src/api/payload/client";

/**
 * Shared wiring around Payload's `useLivePreview` — every preview page in the
 * app (hub cards, hub lists, navbar) sets this up the same way: a stable
 * request handler, a fixed relation depth, and an empty object as the initial
 * doc. Callers layer their own mapping/merging on top of the raw `liveDoc`.
 *
 * @param {Function} requestHandler - Payload live-preview request handler for a collection
 * @param {number} depth - Payload query depth for the live-preview relation fetch
 * @returns {{ liveDoc: Object, isLoading: boolean }}
 */
export function useLivePreviewDoc(requestHandler, depth) {
  const initialDoc = useMemo(() => ({}), []);
  const stableRequestHandler = useCallback(requestHandler, [requestHandler]);

  const { data: liveDoc, isLoading } = useLivePreview({
    initialData: initialDoc,
    serverURL: getPayloadCmsUrl(),
    depth,
    requestHandler: stableRequestHandler,
  });

  return { liveDoc, isLoading };
}
